import $ from 'jquery';
import 'jquery.scrollto';

function expandTiles() {
  const tiles = $('.js-tile');

  tiles.on('click', (event) => {
    const $tile = $(event.currentTarget);
    if ($tile.hasClass('expand')) {
      tiles.removeClass('expand');
    } else {
      tiles.removeClass('expand');
      $tile.addClass('expand');
    }

    const targetScrollPosition = $tile.offset().top;
    $('html, body').animate({ scrollTop: targetScrollPosition }, 600);
  });
}

$(document).ready(() => {
  expandTiles();
});



// WEBPACK FOOTER //
// ./_components/team-members-block/index.js